import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";
import api from "../../api/api";
import { v4 as uuidv4 } from 'uuid';
import { Oval } from "react-loader-spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Icons from "../../utils/icons";
import { faClose, faTrash } from "@fortawesome/free-solid-svg-icons";


export default function Offres({data, open, setOpen}){    
   
    const [loading, setLoading] = useState(false)
    const [name, setName] = useState(data.name)
    const [price, setPrice] = useState(data.price)
    const [duration, setDuration] = useState(data.duration)
    const [bilingCycle, setbilingCycle] = useState(data.bilingCycle)
    const [periodCycle, setPeriodCycle] = useState(data.periodCycle)
    const [nbBoost, setNbBoost] = useState(data.nbBosst)
    const [discount, setDiscount] = useState(data.discount)
    const [trial_period, setTrial_period] = useState(data.trial_period)
    const [feature, setFeature] = useState(data.features)
    const [deleting, setDeleting] = useState(false)
    const [isVisible, setIsVisible] = useState(data.isVisible)



    
    const update = async ()=>{

        try{

            setLoading(true)
            
            await api.post('/offer/update', {
                id : data.id,
                name : name,
                price : price,
                duration : duration,
                bilingCycle : bilingCycle,
                periodCycle : periodCycle,
                nbBoost : nbBoost,
                discount : discount,
                features : feature,
                trial_period : trial_period,
                isVisible : isVisible
            });

            setLoading(false)
            window.location.reload()
            
        }catch(e){
            setLoading(false)
            console.log(e)
        }
    }
    

    return open ? (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div className="w-full max-w-md mx-auto transition-all duration-300 ease-out transform bg-white rounded-lg shadow-xl dark:bg-gray-800">
          
          {/* En-tête : Fermeture et Suppression */}
          <div className="flex items-center justify-between p-4">
            <span
              className="p-2 transition bg-gray-200 rounded-full cursor-pointer dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
              onClick={() => setOpen(false)}
            >
              <FontAwesomeIcon icon={faClose} className="text-gray-600 dark:text-gray-400" />
            </span>

            <span className={`${data.isActif ? 'bg-green-200 font-semibold text-green-800 rounded-xl px-5 cursor-pointer hover:bg-green-400' : 'bg-red-200 font-semibold text-red-800 rounded-xl px-5 cursor-pointer hover:bg-red-400'}`} 
                onClick={async()=>{
                    await api.post('/offer/update', {
                        
                            id : data.id,
                            isActif : !data.isActif
                        
                    })

                    window.location.reload()
                }}
            >
                

                


                
                {data.isActif ? 'Actif' : 'Inactif'}
            </span>
      
            <div
              className="p-2 transition bg-red-200 rounded-full cursor-pointer dark:bg-red-700 hover:bg-red-300 dark:hover:bg-red-600"
              onClick={async () => {
                setDeleting(true);
                await api.post('/offer/delete', { id: data.id });
                setDeleting(false);
                window.location.reload()

              }}
            >
              {!deleting ? (
                <FontAwesomeIcon icon={faTrash} className="text-red-600 dark:text-red-400" />
              ) : (
                <Oval
                  height={20}
                  width={20}
                  color="#ffffff"
                  visible={true}
                  ariaLabel="oval-loading"
                  secondaryColor="#cccccc"
                  strokeWidth={2}
                  strokeWidthSecondary={2}
                />
              )}
            </div>
          </div>
      
          {/* Formulaire */}
          <form className="px-6 py-6" action="" method="POST">
            {/* Nom */}
            <input
              className="block w-full px-4 py-3 mb-4 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              type="text"
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
      
            {/* Prix */}
            <div className="flex items-center gap-4 mb-4">
              <input
                className="block w-full px-4 py-3 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                type="number"
                placeholder="Prix"
                value={price}
                onChange={(event) => setPrice(event.target.value)}
              />
            </div>
      
            {/* Durée et Cycle de facturation */}
            <div className="flex items-center gap-4 mb-4">
              <input
                className="block w-full px-4 py-3 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                type="number"
                placeholder="Durée"
                value={duration}
                onChange={(event) => setDuration(event.target.value)}
              />
              <select
                value={bilingCycle}
                onChange={(event) => setbilingCycle(event.target.value)}
                className="block w-full px-4 py-3 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              >
                <option value="Monthly">Mois</option>
                <option value="Week">Semaine</option>
                <option value="Day">Jour</option>
              </select>
            </div>
      
            {/* Période d'essai */}
            <div className="flex items-center gap-4 mb-4">
              <input
                className="block w-full px-4 py-3 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                type="number"
                value={trial_period}
                placeholder="Période d'essai"
                onChange={(event) => setTrial_period(event.target.value)}
              />
              <select
                value={periodCycle}
                onChange={(event) => setPeriodCycle(event.target.value)}
                className="block w-full px-4 py-3 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              >
                <option value="Monthly">Mois</option>
                <option value="Week">Semaine</option>
                <option value="Day">Jour</option>
              </select>
            </div>
      
            {/* Réduction */}
            <div className="flex items-center gap-4 mb-4">
              <input
                className="block w-full px-4 py-3 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                type="number"
                value={discount}
                placeholder="Réduction (%)"
                onChange={(event) => setDiscount(event.target.value)}
              />
            </div>
      
            {/* Nombre de Boost */}
            <div className="flex items-center gap-4 mb-4">
              <input
                className="block w-full px-4 py-3 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                type="number"
                value={nbBoost}
                placeholder="Nombre de boost"
                onChange={(event) => setNbBoost(event.target.value)}
              />
            </div>
      
            {/* Description */}
            <div className="mb-6">
              <textarea
                className="block w-full px-4 py-3 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                placeholder="Description"
                value={feature}
                onChange={(event) => setFeature(event.target.value)}
              ></textarea>
            </div>


            <div className="mb-6">
                    <input 
                        type="checkbox"
                        checked={isVisible}
                        onChange={(event)=>{
                            setIsVisible(!isVisible)
                        }}
                        id='isVisible'
                        className="rounded-full"
                    />

                    <label for={'isVisible'} className="mx-2 text-sm text-gray-800 dark:text-gray-100">
                        l'offre peut etre visible aux clients ?
                    </label>
                </div>
      
            {/* Bouton Modifier */}
            <div className="flex items-center justify-center">
              <button
                type="button"
                onClick={() => update()}
                className="w-full px-4 py-3 font-semibold text-white transition duration-200 bg-indigo-600 rounded-lg shadow-lg hover:bg-indigo-700 focus:outline-none focus:ring-4 focus:ring-indigo-300"
              >
                {!loading ? 'Modifier' : 
                  <Oval
                    height={20}
                    width={20}
                    color="#ffffff"
                    visible={true}
                    ariaLabel="loading"
                  />
                }
              </button>
            </div>
      
          </form>
        </div>
      </div>
      
    ) : null
}